import { arSA, ca, enUS, es, et, type Locale, ptBR, ru } from "date-fns/locale";
import type { Locales } from "~/i18n/i18n-types";
import { useLocale } from "./use-locale";

const useCalendarLocale = (): Locale => {
	const locale = useLocale() as Locales;

	switch (locale) {
		case "ar":
			return arSA;
		case "es":
			return es;
		case "pt":
			return ptBR;
		case "ca":
			return ca;
		case "ee":
			return et;
		case "ru":
			return ru;
		default:
			return enUS;
	}
};

export default useCalendarLocale;
